<template>
  <div
    class="fb fb-col ff-regular bg-F6F6F6 fb-main-start font-34 height"
    ref="mine"
  >
    <div class="hidden relative bg-FFFFFF mb-12 pb-16">
      <div class="fb fb-between-center">
        <div class="fb fb-between-center fb-main-center item-flex-1">
          <div class="lh-48 p-0-16 item-shrink-0" @click="handlerToSelectDate">
            <span class="font-28">{{ dateStr }}</span
            ><i class="iconfont c-171A1D font-24">&#xe681;</i>
          </div>
          <div
            v-if="switchList && switchList.length"
            class="pr-16 lh-48 item-flex-1 hidden-x"
          >
            <div class="fb fb-cross-center fb-main-end width-full">
              <span
                class="font-28 text-ellipsis inline-block"
                :class="[switchList.length > 1 ? 'w-adapt-24' : 'width-full']"
                @click="handlerToSelectDept"
                >{{ switchList[selectedClassIndex].name }}</span
              >
              <i class="iconfont c-171A1D font-24" v-if="switchList.length > 1"
                >&#xe681;</i
              >
            </div>
          </div>
        </div>
        <!-- 报表 -->
        <div
          class="c-171A1D font-28 text-right fb fb-cross-center fb-main-end pr-16"
          v-if="showToReports"
        >
          <span @click="handlerJumpReportsPage">
            <i class="iconfont mr-4 font-34">&#xe6a9;</i>报表
          </span>
        </div>
      </div>
      <div class="text-center total-score">
        <span class="font-120 ff-ding-condensed-bold">{{
          weekTotalScore
        }}</span>
        <span class="font-24 c-171A1D-60">(分)</span>
      </div>
    </div>
    <div class="bg-F2F2F6">
      <div class="scroll-x bg-FFFFFF width-full">
        <div class="bar-container">
          <md-tabbar
            v-if="tabIndex !== null"
            v-model="tabIndex"
            class="bg-FFFFFF tabbar-content bb"
            indicatorColor="#171A1D"
          >
            <md-tabbar-item
              v-for="item in weekRocordList"
              :key="item.id"
              :name="item.id"
            >
              <span class="font-40 text-bold-600">{{
                item.weekOrderTotalScore
              }}</span>
              <div class="font-28">
                {{ item.name }}
              </div>
            </md-tabbar-item>
          </md-tabbar>
        </div>
      </div>

      <div
        v-if="
          weekRocordList &&
          weekRocordList[realTabIndex] &&
          weekRocordList[realTabIndex].recordList &&
          weekRocordList[realTabIndex].recordList.length
        "
      >
        <div
          class="bg-FFFFFF pt-12 pl-16 pr-16 pb-12 detail-card"
          v-for="(v, index) in weekRocordList[realTabIndex].recordList"
          :key="index"
        >
          <div class="fb fb-main-between fb-cross-center lh-22 mb-9">
            <div class="item-flex-1">
              <span class="c-171A1D">{{ v.evaluationTypeName }}</span>
              <span
                class="mine-rate p-0-10 font-24 text-center ml-4"
                :class="v.score < 0 ? 'mine-rate--reduce' : ''"
                >{{ v.score }}</span
              >
            </div>
            <!-- 可撤销权限：评比老师 且 当日记录 -->
            <div
              class="c-006AFE w-80 text-right"
              @click="backout(v)"
              v-if="
                currentWeekDay &&
                currentWeekDay + '' === currentStartTime + '' &&
                dingUserId === v.evaluationUserDingId
              "
              >撤销</div
            >
          </div>
          <p class="c-111F2C-56 font-28 mb-8" v-if="v.remark">{{ v.remark }}</p>
          <div class="fb">
            <common-upload-img
              :imgs="v.pictureUrls"
              v-if="v.pictureUrls && v.pictureUrls.length"
              :show-only="true"
            ></common-upload-img>
          </div>
          <span class="c-171A1D-40 font-28 block">
            {{ timeFormat(new Date(Number(v.evaluationTime)), 'hh:mm') }}
            {{ v.evaluationUserName }}点评</span
          >
        </div>
      </div>
      <template v-else>
        <div class="h-112 text-center font-28 c-171A1D-40 lh-112 bg-FFFFFF">
          {{ computedEmptyText }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { timeFormat, deepCopy, weekReflectArray } from '@/utils/comUtils'
import commonUploadImg from './commonUploadImg'
import API from '@/api'
import mixin from '@/mixin'
export default {
  name: 'commonClassRankAppraisal',
  mixins: [mixin],
  components: {
    commonUploadImg
  },
  props: {
    dateStr: {
      type: String,
      default: ''
    },
    startDimDay: {
      type: String | Number,
      default: ''
    },
    endDimDay: {
      type: String | Number,
      default: ''
    },
    weekRocordStatistics: {
      type: Object,
      default: null
    },
    switchList: {
      type: Array,
      defalut: null
    },
    showLevel: {
      type: Number,
      defalut: 1
    },
    selectedClassIndex: {
      type: Number,
      defalut: 0
    },
    showToReports: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeFormat: timeFormat,
      weekReflectArray,
      tabIndex: null,
      weekRocordList: [
        {
          id: 1,
          name: '周一',
          weekOrder: 1,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        },
        {
          id: 2,
          name: '周二',
          weekOrder: 2,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        },
        {
          id: 3,
          name: '周三',
          weekOrder: 3,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        },
        {
          id: 4,
          name: '周四',
          weekOrder: 4,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        },
        {
          id: 5,
          name: '周五',
          weekOrder: 5,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        },
        {
          id: 6,
          name: '周六',
          weekOrder: 6,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        },
        {
          id: 0,
          name: '周日',
          weekOrder: 0,
          weekOrderTotalScore: '-',
          badge: '0',
          day: '',
          recordList: []
        }
      ],
      weekTotalScore: 0,
      currentStartTime: new Date(new Date().setHours(0, 0, 0, 0)).getTime()
    }
  },
  computed: {
    currentWeekDay() {
      return (
        (this.weekRocordList.find(v => v.id === this.tabIndex) || {}).day || ''
      )
    },
    computedEmptyText() {
      const _today = timeFormat(new Date(), 'YYYYMMDD')
      const _day = timeFormat(
        new Date(+(this.weekRocordList[this.realTabIndex] || {}).day || 0),
        'YYYYMMDD'
      )
      return +_today >= +_day ? '暂无评比记录' : '未到评比时间'
    },
    realTabIndex() {
      return weekReflectArray(this.tabIndex)
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
    this.$nextTick().then(() => {
      this.methodToCalcScroll()
    })
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      const res = deepCopy(this.weekRocordStatistics)
      if (!res) {
        return
      }
      this.weekTotalScore = res.statistics.weekTotalScore
      res.statistics &&
        res.statistics.weekOrderScoreStatisticsList.map(item => {
          this.weekRocordList[weekReflectArray(item.weekOrder)] = Object.assign(
            this.weekRocordList[weekReflectArray(item.weekOrder)],
            item
          )
        })
      if (res.list && res.list.length) {
        res.list.map(item => {
          if (item.day) {
            var weekOrder = new Date(Number(item.day)).getDay()
            item.list.map(v => {
              v.score = `${v.score > 0 ? '+' : ''}${v.score}`
            })
            this.weekRocordList[weekReflectArray(weekOrder)].dimDay =
              item.dimDay
            this.weekRocordList[weekReflectArray(weekOrder)].recordList =
              item.list
          }
        })
      }
      this.weekRocordList.map((v, index) => {
        if (!v.recordList.length) {
          v.weekOrderTotalScore = '-'
        } else {
          v.weekOrderTotalScore = `${v.weekOrderTotalScore > 0 ? '+' : ''}${
            v.weekOrderTotalScore
          }`
        }
        if (
          v.day &&
          +timeFormat(new Date(+v.day), 'YYYYMMDD') ===
            +timeFormat(new Date(), 'YYYYMMDD')
        ) {
          this.tabIndex = index + 1
          this.$forceUpdate()
        }
      })
      if (!this.tabIndex) {
        this.tabIndex = 1
      }
    },
    methodToCalcScroll() {
      this.scrollHeight = this.$refs.mine.clientHeight
    },
    handlerToSelectDate() {
      this.$emit('handlerToSelectDate')
    },
    handlerToSelectDept() {
      if (this.switchList.length === 1) {
        return
      }
      const that = this
      let columns = that.switchList.reduce((_list, item) => {
        return _list.concat(item.name)
      }, [])
      this.deptPicker = this.$Picker({
        $props: {
          columns,
          defaultActive: this.selectedClassIndex
        },
        $events: {
          confirm(index) {
            that.$emit(
              'handlerSelectClass',
              that.switchList[index[0]],
              index[0]
            )
          }
        }
      }).show()
    },
    backout(item) {
      const that = this
      this.$Dialog({
        type: 'confirm',
        title: '撤销',
        content: `确认撤销本次点评？`,
        onConfirm() {
          that
            .ApiBackout(item)
            .then(() => {
              that
                .$Toast({
                  type: 'success',
                  content: '操作成功'
                })
                .show()
              that.$emit('searchMyApprail')
            })
            .catch(err => {
              that
                .$Toast({
                  type: 'fail',
                  content: err.message || '操作失败'
                })
                .show()
            })
        }
      }).show()
    },
    ApiBackout({ classEvaluationRecordId }) {
      return new Promise((resolve, reject) => {
        API.classrankBackout({
          ...this.commonParams,
          campusId: this.campusId,
          recordId: classEvaluationRecordId,
          operUserRoleTypes: this.$store.getters.currentRole
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              reject(res)
            } else {
              resolve(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    handlerJumpReportsPage() {
      this.$emit('handlerJumpReportsPage')
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-container {
  width: 126%;
}
::-webkit-scrollbar {
  display: none;
}
.detail-card {
  border-bottom: 1px solid rgba(17, 31, 44, 0.12);
  p {
    padding: 8px 16px;
    font-weight: 400;
    margin-bottom: 12px;
    background: #f2f2f6;
    border-radius: 8px;
  }
  & > span {
    padding-bottom: 12px;
    display: block;
  }
  &:last-child {
    border: 0;
  }
}
.mine-rate {
  width: auto;
  border-radius: 22px;
  background: rgba(0, 106, 254, 0.12);
  color: #006afe;
  &--reduce {
    background: rgba(255, 146, 0, 0.12);
    color: #ff9200;
  }
}
.bg-F2F2F6 {
  background: #f2f2f6;
}
.total-score {
  margin-top: 5px;
}
.switch-icon {
  vertical-align: 4px;
}
:deep(.md-tabbar) {
  padding: 0;
}
:deep(.md-tabbar .md-tabbar__item) {
  padding-top: 6px;
  padding-bottom: 8px;
}
</style>
